import {API_ROOT_URL} from 'envs/_current/config'

export const working_app_getWorkingOptions_Api = {
    backend: `Route::get('working-apps/get-options', 'WorkingAppController@getWorkingOptions');`,
    root: API_ROOT_URL,
    path: '/working-apps/get-options',
    method: 'GET',
}